import {
	GetDashboardInquiryListResponse,
	GetDashboardNoticeListResponse,
	GetDashboardNoticeReceiveListResponse,
	GetDashboardStatisticResponse,
	GetDashboardUseTipListResponse,
} from '@/services';
import { formatDate, map } from '@/utils';

export const formatWorkerDashboardStatisticItem = (
	input: GetDashboardStatisticResponse[number]
) => {
	return {
		...input,
	};
};

export const formatWorkerDashboardStatistic = (
	input: GetDashboardStatisticResponse
) => {
	return map(input, formatWorkerDashboardStatisticItem);
};

export const formatWorkerDashboardNoticeDetail = (
	input: GetDashboardNoticeListResponse[number]
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
	};
};

export const formatWorkerDashboardNoticeList = (
	input: GetDashboardNoticeListResponse
) => {
	return map(input, formatWorkerDashboardNoticeDetail);
};

export const formatWorkerDashboardInquiryDetail = (
	input: GetDashboardInquiryListResponse[number]
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
	};
};

export const formatWorkerDashboardInquiryList = (
	input: GetDashboardInquiryListResponse
) => {
	return map(input, formatWorkerDashboardInquiryDetail);
};

export const formatWorkerDashboardUseTipList = (
	input: GetDashboardUseTipListResponse
) => {
	return map(input, formatWorkerDashboardUseTipDetail);
};

export const formatWorkerDashboardUseTipDetail = (
	input: GetDashboardUseTipListResponse[number]
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
	};
};

export const formatWorkerDashboardNoticeReceiveList = (
	input: GetDashboardNoticeReceiveListResponse
) => {
	return map(input, formatWorkerDashboardNoticeReceiveDetail);
};

export const formatWorkerDashboardNoticeReceiveDetail = (
	input: GetDashboardNoticeReceiveListResponse[number]
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
	};
};
